'use client'

import { Dialog, DialogPanel, TransitionChild } from '@headlessui/react'

import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop'
import { TopNavV5AccountPanelContent } from '@src/components/TopNavV5/TopNavV5AccountPanel/TopNavV5AccountPanelContent'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { useHeadlessUIReady } from '@src/hooks/useHeadlessUIReady'
import { cn } from '@src/utils/tailwind'

export const TopNavV5AccountPanel = () => {
  const { isAccountExpanded, setAccountExpanded } = useTopNavV5()
  const isHeadlessUIReady = useHeadlessUIReady()

  return (
    <Dialog
      transition
      open={isAccountExpanded && isHeadlessUIReady}
      onClose={() => setAccountExpanded(false)}
      className="relative z-max transition duration-200 ease-out"
    >
      <ModalBackdrop className="hidden backdrop-blur-sm lg:block" />

      <div className="fixed inset-0 flex justify-end overflow-y-auto">
        <TransitionChild>
          <DialogPanel
            className={cn(
              'size-full max-w-full lg:w-[420px]',
              'duration-200 ease-out data-closed:translate-x-full'
            )}
          >
            <TopNavV5AccountPanelContent />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  )
}
